import SettingsSidebar from './component'

export default SettingsSidebar
